module.exports = __webpack_public_path__ + "img/logo-isc.b58ddd12.svg";